/**
 * Decode HTML entities in a string
 * @param text - The text containing HTML entities
 * @returns The decoded text
 */
export var decodeHtmlEntities = function (text) {
    if (!text)
        return text;
    var textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
};
/**
 * Recursively decode HTML entities in an object, array, or string
 * @param obj - The data to decode (can be string, object, array, etc.)
 * @returns The decoded data with the same structure
 */
export var decodeDeep = function (obj) {
    // If it's a string, decode it
    if (typeof obj === 'string') {
        return decodeHtmlEntities(obj);
    }
    // If it's an array, decode each element
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return decodeDeep(item); });
    }
    // If it's an object, decode each property
    if (obj !== null && typeof obj === 'object') {
        return Object.entries(obj).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            acc[key] = decodeDeep(value);
            return acc;
        }, {});
    }
    // For other types (numbers, booleans, null, etc.), return as-is
    return obj;
};
export var decodeDeepOptimized = function (obj, maxDepth) {
    if (maxDepth === void 0) { maxDepth = 10; }
    // Éviter la récursion infinie
    if (maxDepth <= 0)
        return obj;
    // Cache pour éviter de décoder deux fois la même string
    var cache = new Map();
    var decode = function (item, depth) {
        if (typeof item === 'string') {
            if (cache.has(item))
                return cache.get(item);
            // Ne décoder que si nécessaire
            if (!item.includes('&'))
                return item;
            var decoded = decodeHtmlEntities(item);
            cache.set(item, decoded);
            return decoded;
        }
        if (Array.isArray(item)) {
            return item.map(function (i) { return decode(i, depth - 1); });
        }
        if (item !== null && typeof item === 'object') {
            var result = {};
            for (var _i = 0, _a = Object.entries(item); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                result[key] = decode(value, depth - 1);
            }
            return result;
        }
        return item;
    };
    return decode(obj, maxDepth);
};
